
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import PlageCreneau from '@/extend/classes/PlageCreneau';
import { ColumnConfig } from '@/extend/classes/ListData';

@Module({ name: 'storePlageCreneau' })

export default class storePlageCreneau extends VuexModule {
  // States
  private data: PlageCreneau[] = [];
  private config : ColumnConfig[] = [];
  
  public get plageCreneauLoaded (): boolean {
    return true;
  }
  public get getPlageCreneau () {
    return (id: number): PlageCreneau => {
      const res = this.data.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new PlageCreneau();
        if (id == 0) {
          if (this.data.length == 0) {
            copy.id = -1;
          } else {
            this.data.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.data[0].id - 1);
          }
          this.data.push(copy);
        }
        return copy
      }
    }
  }

  public get listPlageCreneau (): PlageCreneau[] {
    return this.data;
  }

  public get listConfigPlageCreneau (): ColumnConfig[] {
    return this.config;
  }

  @Mutation
  public mPlageCreneauClearData (): void {
    this.data = [];
  }

  @Mutation
  public mPlageCreneauLoaded (objs: PlageCreneau[]): void {
    this.data = [];
    objs.forEach((obj) => {
      this.data.push(obj);
    });
  }

  @Mutation
  public mPlageCreneauUpdated (obj: PlageCreneau): void {
    const api = this.data.find(x => x.id == obj.id);
    if (api != null) {
      api.fromPlageCreneau(obj);
    }
  }

  @Mutation
  public mPlageCreneauDeleted (id: number): void {
    const index = this.data.findIndex(x => x.id == id);
    if (index >= 0) {
      this.data.splice(index, 1);
    }
  }

  @Action
  public registerPlageCreneau (): Promise<boolean> {
    return new Promise((resolve) => {
      resolve(true);
    })
  }

  @Action
  public updatePlageCreneau (obj: PlageCreneau): Promise<PlageCreneau> {
    return new Promise((resolve) => {
        this.mPlageCreneauUpdated(obj);
        resolve(obj)
    })
  }

  @Action
  public deletePlageCreneau (obj: PlageCreneau): Promise<boolean> {
    return new Promise((resolve) => {
        this.mPlageCreneauDeleted(obj.id) 
        resolve(true);
    })
  }
}
